import React from "react";
import { Result } from "antd";
import { Link } from "react-router-dom";

const emailVerified = () => {
  return (
    <div>
      <Result
        status="success"
        title="Email Address Verified Successfully !"
        extra={[
          <Link className="btn btn-primary" to="/signin">
            Continue
          </Link>
        ]}
      />
      ,
    </div>
  );
};

export default emailVerified;
